import { PostTypes } from '../Types';
import VotesTypes from '../Types/VoteTypes';

export const canOnlyUpvote = (parent: any) => {
  const { type: parentType } = parent || {};

  return [PostTypes.PARTICIPATORY_BUDGET, PostTypes.COLLABORATIVE_DECISION].includes(parentType);
};

export const getReactionVotes = (parent: any) => {
  const reactionVotesList = [VotesTypes.SUPPORT];

  if (!canOnlyUpvote(parent)) {
    reactionVotesList.push(VotesTypes.NOT_SUPPORT);
  }

  return reactionVotesList;
};

export const voteTypeValue = (voteType: any) => {
  switch (voteType) {
    case VotesTypes.SUPPORT:
      return 1;
    case VotesTypes.NOT_SUPPORT:
      return -1;
    default:
      return 0;
  }
};

export const getVoteNameByPostType = (parentPostType: any) => {
  if (parentPostType === PostTypes.PARTICIPATORY_BUDGET) {
    return {
      [VotesTypes.SUPPORT]: 'VOTE_FOR',
      [VotesTypes.NOT_SUPPORT]: 'VOTE_AGAINST',
    };
  }

  return {
    [VotesTypes.SUPPORT]: 'SUPPORT',
    [VotesTypes.NOT_SUPPORT]: 'NOT_SUPPORT',
  };
};
